// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ToolsSidebar-cls1__c1940c6412ca28efce93{/*!*/}.ToolsSidebar-cls2__ba88eb18ba4ed7736f4a{position:absolute;top:var(--nav-desktop-height);left:0;width:100vw;overflow:auto;background-color:rgba(0,0,0,.6);z-index:-1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ToolsSidebar-cls1__c1940c6412ca28efce93",
	"cls2": "ToolsSidebar-cls2__ba88eb18ba4ed7736f4a ToolsSidebar-cls1__c1940c6412ca28efce93"
};
export default ___CSS_LOADER_EXPORT___;
